import React from "react";
import DynamicMappingEditor from "features/MappingEditor";
import MappingEditorHeader from "features/MappingEditor/layout/MappingEditorHeader";
import DynamicTableFooter from "features/DynamicTable/components/DynamicTableFooter";

const MappingEditorPage = () => {
  return (
    <div className="bg-white flex flex-col h-screen">
      <MappingEditorHeader />
      <DynamicMappingEditor />
      <DynamicTableFooter />
    </div>
  );
};

export default MappingEditorPage;
